import * as React from 'react';
import { I18n } from 'react-redux-i18n';

import { Loading } from '@common/components/loading';

import { TextEdit } from '../../../text-edit';
import { BackBtn } from '../../../back-btn';
import { Subtitle } from '../../../subtitle';

import { useNieceNephewPageController } from './niece-nephew-page.controller';
import { NieceNephewPageProps } from './niece-nephew-page.types';
import { TextEditor } from '../../../text-editor';

import './niece-nephew-page.styles.scss';

export const NieceNephewPage: React.FC<NieceNephewPageProps> = (props) => {
  const { cachedData, onGoBack, errors } = props;

  const {
    loadingPage,
    handlePageNameChange,
    handlePageDescriptionChange,
  } = useNieceNephewPageController(props);
  
  if (loadingPage || !cachedData) {
    return (
      <div className="FhqDesignToolQuestionnaireDesignerPage">
        <Loading size={20} margin="20px" />
      </div>
    );
  }

  return (
    <div className="FhqDesignToolQuestionnaireDesignerNieceNephewPage">
      <BackBtn className="FhqDesignToolQuestionnaireDesignerNieceNephewPage__back-btn" onClick={onGoBack} />
      <TextEdit 
        errors={errors?.properties?.title}
        required
        metadata={{
          description: 'page-name',
        }}
        value={cachedData.title}
        onChange={handlePageNameChange}
      />
      <Subtitle type="chip" text={I18n.t('Siblings')} />
      <TextEditor
        metadata={{
          description: 'page-description',
        }}
        label={I18n.t('Page Description')}
        value={cachedData.description ?? ''}
        onChange={handlePageDescriptionChange}
      />
    </div>
  );
};